import { AuthorInterface } from '../types/Author';
import { apiUrls } from './apiUrls';
import { makeRequest } from './request';

class Author implements AuthorInterface {
  readonly apiKey: string;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
  }

  async getPromptsByAuthor(authorName: string): Promise<any> {
    try {
      return await makeRequest('GET', apiUrls.prompts.byAuthor(authorName), this.apiKey);
    } catch (error) {
      console.error('Error fetching prompts by author:', error);
    }
  }

  async getFlowsByAuthor(authorName: string): Promise<any> {
    try {
      return await makeRequest('GET', apiUrls.flows.byAuthor(authorName), this.apiKey);
    } catch (error) {
      console.error('Error fetching flows by author:', error);
    }
  }
}

export default Author;
